import CrossSectionIcon from "@/assets/icons/CrossSection.svg";
import type { SvgComponentProps } from "@/style/img/MapSvg";
import type React from "react";

const CrossSectionSvg: React.FunctionComponent<SvgComponentProps> = ({ className }) => (
  <img src={CrossSectionIcon} alt="Icon" className={className} />
);

export default CrossSectionSvg;
